<template>
    <div class="school_home">
        <div class="school1">
            <div class="s1_cont">
                <input type="text" placeholder="推荐院校：伦敦艺术大学" v-model="input1" @keydown="enterSubmit">
                <img src="../img/名校导航/Group 351.png" alt="" @click="searchSchool()">
            </div>
        </div>

        <div class="school2" id="school2">
            <div class="s2_titleBox">
                <div class="s2_title" @click="toggleTitle(0)" style="background-color: #5F9DF7;font-weight: bold;">
                    <div>意向国家/地区</div>
                    <img src="../img/名校导航/Group 646.png" alt="">
                </div>
                <div class="s2_title" @click="toggleTitle(1)" style="background-color: #fff">
                    <div>意向专业/方向</div>
                    <img src="../img/名校导航/Group 646.png" alt="">
                </div>

            </div>
            <div class="s2_cont">
                <div class="item1" v-for="(item, index) in countryData" :class="{ item1bgc: item.id == countryId }"
                    @click="getcountryId(item.id)">{{ item.cname }}
                </div>
            </div>
            <div class="s2_cont" style="display: none;">
                <div class="swiper mySwiperSC1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in majorData">

                            <div class="item1" v-for="(item2, index2) in item" :class="{ item2bgc: item2.id == majorId }"
                                @click="getmajorId(item2.id)">{{ item2.cname }}
                            </div>

                        </div>
                    </div>

                    <div class="swiper-pagination"></div>
                </div>

            </div>
        </div>

        <div class="school3">
            <div class="s3_cont">
                <div class="s3_item" v-for="(item, index) in schoolsData" @click="jopschoolDetail(item.id,item.cname)">
                    <div class="s3_item_left">
                        <div>
                            <div class="s3_item_imgbox">
                                <img :src="'https://public.rossoarts.com/static/uploads/' + item.logo" alt="">
                                <p class="s3_title_cn">{{ item.cname }}</p>
                                <p class="s3_title_en">{{ item.ename }}</p>
                            </div>
                            <div class="s3_pBox" style="margin-top: .1rem;">
                                <p class="s3_pTtitle">申请难度：</p>
                                <el-rate v-model="rateValue" disabled text-color="#ff9900" :colors="colors"
                                    score-template="{value}">
                                </el-rate>
                            </div>
                            <div class="s3_pBox">
                                <p class="s3_pTtitle">学费：</p>
                                <div>{{ item.tuition }}</div>
                            </div>
                            <div class="s3_pBox">
                                <p class="s3_pTtitle">语言成绩：</p>
                                <div>雅思: 6.0｜托福:N/A｜SAT:N/A</div>
                            </div>
                            <div class="s3_pBox">
                                <p class="s3_pTtitle">申请截止：</p>
                                <div>{{ item.off_date }}</div>
                            </div>
                            <div class="s3_pBox">
                                <p class="s3_p_major">
                                    <span class="s3_pTtitle">专业推荐：</span>{{ item.major_id }}
                                </p>
                                <!-- <p></p> -->
                            </div>
                        </div>
                        <div class="itemMore_box">
                            <div class="itemMore">
                                <img src="../img/名校导航/Group 152.png" alt="">
                                <p>了解更多</p>
                            </div>
                            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" class="itemMore_add"
                                @click="jopkefu($event)">

                                <img src="../img/名校导航/Group 456.png" alt="">
                                <p>即刻咨询</p>

                            </a>

                        </div>
                    </div>
                    <div class="s3_item_right">
                        <img :src="'https://public.rossoarts.com/static/uploads/' + item.school_img_small" alt="">
                        <div class="top_div">
                            <p class="en">{{ item.admission_num }}</p>
                            <p class="item_mei">枚</p>
                        </div>
                    </div>
                </div>

                <div class="s3_more" @click="getmoreSchool()">
                    <div>查看更多</div>
                    <div class="s3_more_line1"></div>
                    <div class="s3_more_line2"></div>
                </div>
            </div>
        </div>

        <div class="school4">
            <div class="section_box">
                <div class="section_title_cn">热门专业</div>
                <div class="section_title_en">POPULAR MAJORS</div>
            </div>
            <div class="s4_cont">
                <div class="s4_item" @click="jopMajorDetail(2)">
                    <img src="https://public.rossoarts.com/static/uploads/20230423/b65a5b8b5e819cd33a1fe8acd1915c7a.png" alt="" class="s4_item_img">
                    <div class="s4_item_textBox">
                        <div class="s4_item_cn">服装设计</div>
                        <div class="s4_item_en">Fashion Design</div>
                    </div>
                    <img src="../img/名校导航/Group 647.png" alt="" class="s4_item_icon">
                </div>
                <div class="s4_item" @click="jopMajorDetail(4)">
                    <img src="https://public.rossoarts.com/static/uploads/20230427/321a64234d18b71a912183b18c2c35e8.png" alt="" class="s4_item_img">
                    <div class="s4_item_textBox">
                        <div class="s4_item_cn">动画设计</div>
                        <div class="s4_item_en">Animation</div>
                    </div>
                    <img src="../img/名校导航/Group 647.png" alt="" class="s4_item_icon">
                </div>
                <div class="s4_item" @click="jopMajorDetail(1)">
                    <img src="https://public.rossoarts.com/static/uploads/20230423/41d6d518d4fcdb297c8a32a895c4dd47.png" alt="" class="s4_item_img">
                    <div class="s4_item_textBox">
                        <div class="s4_item_cn">平面设计</div>
                        <div class="s4_item_en">Graphic Design</div>
                    </div>
                    <img src="../img/名校导航/Group 647.png" alt="" class="s4_item_icon">
                </div>
                <div class="s4_item" @click="jopMajorDetail(20)">
                    <img src="https://public.rossoarts.com/static/uploads/20230427/e8612b3910c04a2d63385653831a2b5f.png" alt="" class="s4_item_img">
                    <div class="s4_item_textBox">
                        <div class="s4_item_cn">交互设计</div>
                        <div class="s4_item_en">Interaction Design</div>
                    </div>
                    <img src="../img/名校导航/Group 647.png" alt="" class="s4_item_icon">
                </div>
                <div class="s4_item" @click="jopMajorDetail(26)">
                    <img src="https://public.rossoarts.com/static/uploads/20230427/f0d087ce3a161b54d05eb008af13e1de.png" alt="" class="s4_item_img">
                    <div class="s4_item_textBox">
                        <div class="s4_item_cn">游戏设计</div>
                        <div class="s4_item_en">Game Design</div>
                    </div>
                    <img src="../img/名校导航/Group 647.png" alt="" class="s4_item_icon">
                </div>
                <div class="s4_item" @click="jopMajorDetail(13)">
                    <img src="https://public.rossoarts.com/static/uploads/20230427/d973e03453fcb951f41ce9dbf567d1cb.png" alt="" class="s4_item_img">
                    <div class="s4_item_textBox">
                        <div class="s4_item_cn">建筑设计</div>
                        <div class="s4_item_en">Architecture Design</div>
                    </div>
                    <img src="../img/名校导航/Group 647.png" alt="" class="s4_item_icon">
                </div>
               
            </div>
        </div>
        <!-- 最外层div -->
    </div>
</template>
<script>
import "@/assets/css/schools.css"
import Swiper from 'swiper/bundle'
import 'swiper/css/pagination';
import axios from "axios"
export default {
    data() {
        return {
            countryData: [],
            majorData: [],
            countryId: 0,
            majorId: 0,
            schoolsData: [],
            schoolsTotal: 0,
            limit: 6,
            rateValue: 3.5,
            colors: ['#99A9BF', '#FB6333', '#FF9900'],
            input1:"",
            hotMajor:[]
        }
    },
   
    created() {
        this.getCountry()
        this.getArtsMajor()
        this.getArtsSchools()
    
    },
    methods: {
        jopMajorDetail(val){
            this.$router.push(`/majors/${val}.html`)
        },
        jopschoolDetail(val,val2){
            // this.$router.push(`/schools/${val}.html`)
            this.$router.push({
              
              path:  `/schools/${val}.html?cname=${val2}`,
            
          })
        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        enterSubmit() {
            if (event.keyCode == 13) {
                this.searchSchool()
            }
        },
        getmoreSchool() {
            var s3_more = document.getElementsByClassName("s3_more")
           
            this.limit += 6
            this.getArtsSchools()
            
        },
       
        searchSchool() {
            // console.log(this.input1, "inpu1");
            // if (this.input1) {

            // } else {
            //     this.input1 = "伦敦艺术大学"
            // }
            axios.get(`https://public.rossoarts.com/api/v1/searchSchool?wd=${this.input1}`).then((data) => {
                // console.log(data.data);
                this.schoolsData = data.data
                this.schoolsTotal = data.total
            })

            school2.scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
            var s3_more = document.getElementsByClassName("s3_more")
            s3_more[0].style.display = "none"
        },
        toggleTitle(val) {
            this.limit = 0
            var s2_title = document.getElementsByClassName("s2_title")
            var s2_cont = document.getElementsByClassName("s2_cont")

            for (var i = 0; i < s2_title.length; i++) {
                s2_title[i].style.backgroundColor = "#fff"
                s2_title[i].style.fontWeight = "400"
                s2_cont[i].style.display = "none"
            }
            s2_title[val].style.backgroundColor = "#5F9DF7"
            s2_title[val].style.fontWeight = "bold"
            s2_cont[val].style.display = "flex"
        },
        getCountry() {
            axios.get("https://public.rossoarts.com/api/v1/getCountry").then((data) => {
                // console.log(data.data.data);
                this.countryData = data.data.data
            })
        },
        getArtsMajor() {
            axios.get("https://public.rossoarts.com/api/v1/getArtsMajor").then((data) => {
                // console.log(data.data.data.splice(0,30));

                this.majorData = this.arrGroup(data.data.data.splice(0, 30), 12)
                // console.log(this.majorData);
            })
        },
        getcountryId(val) {
            this.limit = 6
            var s3_more = document.getElementsByClassName("s3_more")
            s3_more[0].style.display = "flex"
            this.countryId = val
            // console.log(val);
            this.getArtsSchools()
            var item1 = document.getElementsByClassName("item1")
            school2.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
            })
        },
        getmajorId(val) {
            this.limit = 6
            var s3_more = document.getElementsByClassName("s3_more")
            s3_more[0].style.display = "flex"
            this.majorId = val
            // console.log(val);
            this.getArtsSchools()
            school2.scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
         
        },
        hidS3more(){
            var s3_more = document.getElementsByClassName("s3_more")
            if( this.limit > this.schoolsTotal){
                s3_more[0].style.display = "none"
            }else{
                s3_more[0].style.display = "flex"
            }
          
        },
        getArtsSchools() {
            
            axios.get(`https://public.rossoarts.com/api/v1/getArtsSchools?c=${this.countryId}&m=${this.majorId}&limit=${this.limit}&page=${this.schoolsPage}`).then((data) => {
                // console.log(data);
                // this.majorData = data.data.data
                this.schoolsTotal = data.data.data.total
                this.schoolsData = data.data.data.data
               
                this.hidS3more()
               
            })
        },
        swiperSC1() {
            var swiper = new Swiper(".mySwiperSC1", {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + "</span>";
                    },
                },
            });
        },
    },
    mounted() {
        this.swiperSC1()
    }
}
</script>